"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import { motion } from "framer-motion";
import { FaAndroid, FaApple } from "react-icons/fa";
import { brokerageCaseStudy } from "./brokerage.data";
import Image from "next/image";
const ease = [0.17, 0.85, 0.438, 0.99] as const;

/* Light placeholder until the real mockup is added to /public/images/brokerage/ */
const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='420' height='700'%3E%3Crect width='420' height='700' rx='28' fill='%23ffffff' fill-opacity='0.45'/%3E%3C/svg%3E";
const platformIcons: Record<string, typeof FaAndroid> = {
  Android: FaAndroid,
  iPhone: FaApple
};
const platformColors: Record<string, string> = {
  Android: "text-[#3DDC84]",
  iPhone: "text-[#0b1354] dark:text-white"
};
export default function CaseStudy() {
  const $ = _c(37);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6,
      ease
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t5 = <motion.h2 initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="font-poppins mb-5 text-[1.9rem] font-bold leading-tight text-[#0b1354] sm:text-[2.25rem] lg:text-[2.6rem] dark:text-white">Our Successful Brokerage Solutions</motion.h2>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-base leading-[1.75] text-[#5b6b7d] dark:text-gray-400">We have delivered cutting-edge order brokerage platforms designed for efficiency, security, and scalability. Our projects focus on streamlining operations, reducing processing time, and ensuring seamless transactions for businesses.</p>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5) {
    t7 = <div className="mx-auto mb-12 max-w-3xl text-center">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== desktopAnimations) {
    t8 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[15] = desktopAnimations;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== desktopAnimations) {
    t9 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[17] = desktopAnimations;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== desktopAnimations) {
    t10 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[19] = desktopAnimations;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      duration: 0.7,
      ease
    };
    t12 = {
      once: true,
      amount: 0.2
    };
    $[21] = t11;
    $[22] = t12;
  } else {
    t11 = $[21];
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Image src="/images/brokerage/three-person.svg" alt="Icon of three team members collaborating" width={64} height={64} className="mb-7 h-16 w-16 object-contain transition-transform duration-500 group-hover:scale-105 dark:bg-white dark:rounded dark:p-2" />;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  let t15;
  let t16;
  let t17;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="mb-7 flex flex-wrap items-center gap-3">{brokerageCaseStudy.platforms.map(_temp)}</div>;
    t15 = <h3 className="font-poppins mb-4 text-[1.15rem] font-bold uppercase tracking-[0.02em] text-[#0b1354] dark:text-white">{brokerageCaseStudy.name}</h3>;
    t16 = <p className="mb-9 max-w-lg text-base leading-[1.8] text-[#5b6b7d] dark:text-gray-300">{brokerageCaseStudy.description}</p>;
    t17 = <p className="font-poppins mb-5 text-[1.35rem] font-bold text-[#0b1354] dark:text-white">The Result?</p>;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
  } else {
    t14 = $[24];
    t15 = $[25];
    t16 = $[26];
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="flex flex-col justify-center">{t13}{t14}{t15}{t16}{t17}<div className="grid max-w-md grid-cols-2 gap-8">{brokerageCaseStudy.results.map(_temp2)}</div></div>;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="relative flex items-center justify-center py-4"><Image src={brokerageCaseStudy.image} alt={`${brokerageCaseStudy.name} app screens`} width={330} height={550} loading="lazy" className="relative z-10 w-full max-w-[330px] rotate-[8deg] object-contain drop-shadow-[0_25px_50px_rgba(13,38,76,0.35)] transition-transform duration-500 group-hover:rotate-[5deg] group-hover:scale-[1.03]" onError={_temp3} /></div>;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== t10 || $[31] !== t8 || $[32] !== t9) {
    t20 = <motion.div initial={t8} whileInView={t9} animate={t10} transition={t11} viewport={t12} className="group grid grid-cols-1 items-center gap-12 overflow-hidden rounded-[18px] bg-[linear-gradient(to_bottom,#c7ecff_0%,#f9efff_100%)] px-8 py-12 transition-all duration-500 hover:shadow-[0_28px_70px_-30px_rgba(13,38,76,0.45)] md:px-14 lg:grid-cols-2 lg:gap-10 lg:px-16 lg:py-16 dark:bg-[linear-gradient(to_bottom,#1e293b_0%,#0f172a_100%)]">{t18}{t19}</motion.div>;
    $[30] = t10;
    $[31] = t8;
    $[32] = t9;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t20 || $[35] !== t7) {
    t21 = <section className="overflow-hidden bg-white px-6 py-16 font-sans md:py-24 dark:bg-gray-900"><div className="mx-auto w-full max-w-7xl">{t7}{t20}</div></section>;
    $[34] = t20;
    $[35] = t7;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  return t21;
}
function _temp3(e) {
  e.currentTarget.onerror = null;
  e.currentTarget.src = PLACEHOLDER;
}
function _temp2(result) {
  return <div key={result.label}><p className="font-poppins mb-1 text-[1.75rem] font-bold leading-none text-[#0b1354] dark:text-white">{result.value}</p><p className="text-[15px] leading-[1.6] text-[#5b6b7d] dark:text-gray-300">{result.label}</p></div>;
}
function _temp(platform) {
  const Icon = platformIcons[platform];
  return <span key={platform} className="inline-flex items-center gap-2 rounded-[6px] bg-white px-4 py-2 text-[14px] font-medium text-[#0b1354] shadow-[0_2px_10px_-4px_rgba(13,38,76,0.25)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_20px_-8px_rgba(13,38,76,0.4)] dark:bg-gray-800 dark:text-white">{Icon ? <Icon aria-hidden={true} className={`h-4 w-4 ${platformColors[platform] ?? ""}`} /> : null}{platform}</span>;
}